<template>
  <sa-page-layout
    :titolo="titolo"
    :pathResource="pathResource"
    :linkedit="linkedit"
    :btnRefreshVisible="true"
    :btnNewVisible="true"
    @refresh="onRefresh"
    :showModalLoading="showModalLoading"
  >
    <template slot="table-header">
      <b-row
        class="sa-label-info"
        style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem"
      >
        <b-col cols="6" lg="6">
          <label class="sa-label-data">Nome Report</label>
          <b-form-input type="text" v-model="filtro.nomeReport"></b-form-input>
        </b-col>
        <b-col cols="6" lg="6">
          <label class="sa-label-data">Struttura</label>
          <b-form-select
              v-model="filtro.struttura"
              :options="struttureRiferimentoOptions"
              :value="null"
              value-field="denominazione"
              text-field="denominazione"
            >
              <template #first>
                <b-form-select-option :disabled="true" :value="null"
                  >- Seleziona -</b-form-select-option
                >
              </template>
            </b-form-select>
        </b-col>
      </b-row>
      <b-row
        class="sa-padding-right text-right"
        style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem"
      >
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <b-button type="submit" v-on:click="submit" variant="info">{{
            this.$i18n.t("patients.lblFind")
          }}</b-button>
          <b-button type="reset" v-on:click="onReset" variant="danger">{{
            this.$i18n.t("patients.lblResetFilter")
          }}</b-button>
        </b-col>
      </b-row>
      <b-row
        class="sa-label-info"
        style="margin-left: 0.5rem; margin-right: 0.5rem"
      >
        <b-col cols="6" lg="3">
          <p>
            {{ this.$i18n.t("global.lblTotalRecords") }}: {{ rowsReportName }}
          </p>
        </b-col>
        <b-col cols="6" lg="9">
          <b-pagination
            v-model="currentPageReportName"
            :total-rows="rowsReportName"
            :per-page="perPageReportName"
            align="right"
            size="sm"
          ></b-pagination>
        </b-col>
      </b-row>
    </template>
    <template slot="table-body">
      <div class="b-table-sticky-header">
        <b-table
          sticky-header
          ref="table"
          stacked="xl"
          striped
          hover
          responsive="sm"
          :items="items"
          :fields="fieldsGruppoReports"
          :current-page="1"
          :per-page="perPageReportName"
          sort-icon-left
          head-variant="light"
          class="sa-b-table"
        >
          <template #row-details="">
            <b-row
              class="sa-label-info"
              style="margin-left: 0.5rem; margin-right: 0.5rem"
            >
              <b-col cols="6" lg="3">
                <p>{{ "Record Totali" }}: {{ rowsDetail }}</p>
              </b-col>
              <b-col cols="6" lg="9">
                <b-pagination
                  v-model="currentPageReportName"
                  :total-rows="rowsReportName"
                  :per-page="perPageReportName"
                  align="right"
                  size="sm"
                ></b-pagination>
              </b-col>
            </b-row>
            <div class="b-table-sticky-header">
              <b-table
                sticky-header
                ref="table"
                stacked="xl"
                striped
                hover
                responsive="sm"
                :items="itemsDetail"
                :fields="fieldsDetail"
                :current-page="1"
                :per-page="perPageDetail"
                sort-icon-left
                head-variant="light"
                class="sa-b-table"
              >
              <template v-slot:cell(actions)="row">
            <b-container class="bv-example-row">
                <b-button
                size="sm"
                v-b-tooltip.hover
                title="Ripristina"
                variant="outline-info"
                @click="onRipristinaVersione(row)"
              >
                <font-awesome-icon icon="undo-alt" />
              </b-button>
            </b-container>
          </template>
            </b-table>
            </div>
          </template>
          <template v-slot:cell(reportName)="{ item }">
            <router-link class="sa-edit-link" :to="'/printserver/view/' + item.id">{{ item.reportName.toUpperCase()}}</router-link>
          </template>
          <template v-slot:cell(versione)="{ item }">
            <strong>{{ item.versione }}</strong>
          </template>         
          <template v-slot:cell(actions)="row">
            <b-container class="bv-example-row">
                <b-button v-if="row.item.versione >1"
                size="sm"
                v-b-tooltip.hover
                title="Storico"
                variant="outline-primary"
                @click="onClickStorico(row)"
              >
                <font-awesome-icon :icon="row.item._showDetails ? 'arrow-down':'arrow-left'" />
              </b-button>
              <b-button
                size="sm"
                v-b-tooltip.hover
                title="Aggiungi Versione"
                variant="outline-success"
                @click="onAggiungiNuovaVersione(row.item)"
              >
                <font-awesome-icon icon="plus" />
              </b-button>
              <b-button
                size="sm"
                v-b-tooltip.hover
                title="Duplica"
                variant="outline-success"
                @click="onDuplicaRecord(row.item)"
              >
                <font-awesome-icon icon="copy" />
              </b-button>
            </b-container>
          </template>
        </b-table>
      </div>
    </template>
    <template slot="table-footer">
      <b-modal ref="mdlCopyRecordFile" 
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        centered
        size="medium" 
        style="height: 100% !important">
        
        <template #modal-title>
          <span><font-awesome-icon icon="file" /> Copia Vesione </span>
        </template>
        <template #default>
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <strong>{{ messageErrorCopyRecord }}</strong>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label class="sa-label-data">Struttura Riferimento</label>
            <b-form-select
              v-model="selectStrutturaModal"
              :options="struttureRiferimentoOptions"
              :value="null"
              value-field="denominazione"
              text-field="denominazione"
              @change="onChangeStrutturaSelezionata()"
            >
              <template #first>
                <b-form-select-option :disabled="true" :value="null"
                  >- Seleziona -</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label class="sa-label-data">Descrizione</label>
            <b-form-input :disabled="isCopiaBottomDisabled" v-model="descrizioneRecordCopiato"></b-form-input>
          </b-col>
        </b-row>
       
        </template>
        <template #modal-footer>
 
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Copia Record"
            variant="outline-info"
            @click="onCopiaRecord()"
            :disabled="isCopiaBottomDisabled"
            
          >
            Copia
            <font-awesome-icon icon="plus" />
          </b-button>
        </template>
      </b-modal>
      <b-modal ref="mdlRecoveryRecord" 
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        centered
        size="medium" 
        style="height: 100% !important">
        
        <template #modal-title>
          <span><font-awesome-icon icon="file" /> Ripristina Vesione {{ itemRecovery.versione }} </span>
        </template>
        <template #default>
          <b-row>
        
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <span >Sicuro di voler ripristinare  {{ itemRecovery.reportName }} versione {{ itemRecovery.versione }} per struttura {{ itemRecovery.codiceStruttura }}</span>
          </b-col>
        </b-row>
       
        </template>
        <template #modal-footer>
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Annulla e torna alla lista"
            variant="outline-danger"
            @click="onAnnullaRipristino()"
          >
            Annulla
            <font-awesome-icon icon="times-circle" />
          </b-button>
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Ripristina"
            variant="outline-success"
            @click="onRipristina()"
          >
            Ripristina
            <font-awesome-icon icon="times-circle" />
          </b-button>
        </template>
      </b-modal>
      
      <pdf-print-view-embedded
        ref="pdfPrintViewEmbedded"
        :pdf="pdfViewer"
      ></pdf-print-view-embedded>
      <b-row
        class="sa-label-info"
        style="margin-left: 0.5rem; margin-right: 0.5rem"
      >
        <b-col cols="6" lg="3">
          <p>
            {{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rowsReportName }}
          </p>
        </b-col>
        <b-col cols="6" lg="9">
          <b-pagination
            v-model="currentPageReportName"
            :total-rows="rowsReportName"
            :per-page="perPageReportName"
            align="right"
            size="sm"
          ></b-pagination>
        </b-col>
      </b-row>
    </template>
  </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PdfPrintViewEmbedded from "../../utility/components/PdfPrintViewEmbedded.vue";
import moment from 'moment';
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  mixins:[UtilityMixin],
  components: { SaPageLayout, PdfPrintViewEmbedded },
  mounted() {
    let me = this;
    me.loadData();
    me.loadStruttureRiferimento();
  },
  data() {
    return {
      selectStrutturaModal:null,
      recordSelezionatoCopy:null,
      descrizioneRecordCopiato:"",
      messageErrorCopyRecord:"",
      isCopiaBottomDisabled:false,
      nomiFileOptions:[],
      itemRecovery : {
        versione:0
      },
      pdfViewer: null,
      currentPageReportName: 1,
      currentPageDetail: 1,
      
      perPageReportName: 30,
      perPageDetail: 5,
      rowsReportName: 0,
      rowsDetail: 0,
      selectedRowDetail: null,
      titolo: "Print Server List",
      showModalLoading: false,
      linkedit: "/printserver",
      pathResource: "/printserver",
      linkNomiFile: "/printserver/nomifile",
      filtro: {
        nomeReport: null,
        forPage: 10,
        page: 1,
        struttura:null
      },
      filtroDetail: {
        nomeReport: null,
        forPage: 5,
        page: 1,
      },
      items: [],
      itemsDetail: [],
      struttureRiferimentoOptions:[],
      statiReportOptions: [
        { value: null, text: "TUTTI" },
        { value: "ATTIVO", text: "ATTIVO" }
      ],
      fieldsGruppoReports: [
        {
          label: "Report Name",
          key: "reportName",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "Struttura",
          key: "codiceStruttura",
          sortable: true,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "File",
          key: "nomeFile",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "Desrizione",
          key: "descrizione",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "Versioni",
          key: "versione",
          sortable: true,
          //thStyle: "width: 12rem",
        },
        {
          label: "Ultima Modifica",
          key: "updateDate",
          sortable: true,
          formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY");
                        } else {
                            return "-----";
                        }
                    },
          //thStyle: "width: 12rem",
        },
        {
          label: "Stato",
          key: "stato",
          sortable: true,
          //thStyle: "width: 12rem",
        },
        { class: "sa-table-column-action-double", key: "actions", label: "" },
      ],
      fieldsDetail: [
        {
          label: "Report Name",
          key: "reportName",
          sortable: true,
          thStyle: "width: 6rem",
          class: "text-left",
        },
        {
          label: "Nome File",
          key: "nomeFile",
          sortable: true,
          thStyle: "width: 12rem",
        },
        {
          label: "Struttura",
          key: "codiceStruttura",
          sortable: true,
          thStyle: "width: 12rem",
        },
        {
          label: "Descrizione",
          key: "descrizione",
          sortable: true,
          align: "left",
          thStyle: "width: 18rem",
        },
        {
          label: "Versione",
          key: "versione",
          sortable: true,
          thStyle: "width: 8rem",
        },
        {
          label: "Stato",
          key: "stato",
          sortable: true,
          thStyle: "width: 8rem",
        },
        { class: "sa-table-column-action-double", key: "actions", label: "" },
      ],
    };
  },
  methods: {
    loadData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource;
      me.filtro.forPage = me.perPageReportName;
      me.filtro.page = me.currentPageReportName;
      me.filtro.stato = "ATTIVO";
      me.showModalLoading = true;
      UtilityMixin.methods.restCallGet(link,me.filtro,me.loadDataSuccessResponse,me.loadDataErrorResponse);
    },
    loadDataSuccessResponse(response){
      let me = this;
      if(response.data.data)
        me.items = [];
          me.rowsReportName = response.data.data.recordsNumber;
          me.items = response.data.data.list;
          me.showModalLoading = false;

    },
    loadDataErrorResponse(error){
      let me = this;
      me.showModalLoading = false;
      console.log(error);
      
    },
    loadDataDetailByNomeReport(nomeReport,codiceStruttura) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource;
      me.filtroDetail.forPage = me.perPageDetail;
      me.filtroDetail.page = me.currentPageDetail;
      me.filtroDetail.nomeReport = nomeReport;
      me.filtroDetail.struttura = codiceStruttura
      me.filtroDetail.stato = "DEPRECATO";
      me.showModalLoading = true;
      axios
        .get(link, { params: me.filtroDetail })
        .then((response) => {
          me.itemsDetail = [];
          me.rowsDetail = response.data.data.recordsNumber;
          me.itemsDetail = response.data.data.list;
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    loadStruttureRiferimento() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + "/strutture";
      UtilityMixin.methods.restCallGet(
        link,
        {},
        me.loadStruttureRiferimentoSuccess,
        me.loadStruttureRiferimentoError
      );
    },
    loadNomiFile(struttura,callback) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkNomiFile;
      axios.get(link , {params:{struttura:struttura}}).then((response) => {
        me.nomiFileOptions = [];
        if(response.data.data)
        me.nomiFileOptions = response.data.data.list
      
        if(callback)
        callback(me.nomiFileOptions);
      });
    },
    loadStruttureRiferimentoSuccess(response) {
      let me = this;
      if (response.data) me.struttureRiferimentoOptions = response.data.data;
      me.showModalLoading = false;
    },
    loadStruttureRiferimentoError(error) {
      let me = this;
      console.log(error);
      me.showModalLoading = false;
    },
    onAggiungiNuovaVersione(item) {
        let me = this;
        me.$router.push({ path: "/printserver/edit/" +item.id });
    },
    onRefresh() {
      let me = this;
      me.loadData();
    },
    onDuplicaRecord(item){
      let me = this;
      me.recordSelezionatoCopy= null
      me.recordSelezionatoCopy=item;
      me.$refs.mdlCopyRecordFile.show();
    },
    onChangeStrutturaSelezionata(){
      let me = this;
      me.loadNomiFile(me.selectStrutturaModal, (nomiFileOptions) => {
        me.messageErrorCopyRecord = ""; 
      me.isCopiaBottomDisabled=false;
    if(nomiFileOptions.length > 0){
      me.messageErrorCopyRecord = "FILE GIA' PRESENTE PER STRUTTURA "+me.selectStrutturaModal + " PROCEDERE AL VERSIONING!"; 
      me.isCopiaBottomDisabled=true;
    }
  });
    },

    onCopiaRecord(){
      let me = this;
      me.recordSelezionatoCopy.strutturaCopy = me.selectStrutturaModal;
      me.recordSelezionatoCopy.copy = true;
      me.recordSelezionatoCopy.descrizione = me.descrizioneRecordCopiato;
      let link = process.env.VUE_APP_PATH_API + me.pathResource;
      delete me.recordSelezionatoCopy._showDetails;
      axios.post(link,me.recordSelezionatoCopy)
      .then((response)=>{
        console.log(response);
        me.selectedRowDetail = null;
        me.descrizioneRecordCopiato = null;

      }).catch((err)=>{
        console.log(err);
        
      });

    },
    onAnnullaCopy(){
      let me = this;
      me.recordSelezionatoCopy= {
        descrizioneN:""
      };
      me.selectStrutturaModal = null;
      me.$refs.mdlCopyRecordFile.hide();
    },
    onClickStorico(row) {
      let me = this;
      if (me.selectedRowDetail) {
        if (me.selectedRowDetail.index === row.index) {    
            if(row.detailsShowing){
                row.toggleDetails();
                me.selectedRowDetail = null;
                me.itemsDetail = [];
            }
          return;
        } else {
          me.selectedRowDetail.toggleDetails();
        }
      }
      row.toggleDetails();
      me.selectedRowDetail = row;
      me.itemsDetail = [];
      const nomeFile = row.item.reportName;
      me.loadDataDetailByNomeReport(nomeFile,row.item.codiceStruttura);
    },
    onReset() {
      let me = this;
      me.filtro = {
        nomeReport: null,
        struttura:null
      };
      me.selectedRowDetail = null;
      me.loadData();
    },
    onClickGoTo(url) {
      let me = this;
      me.selectedRowDetail = null;
      me.$router.push(url);
    },
    submit() {
      let me = this;
      me.selectedRowDetail = null;
      me.loadData();

    },
    onRipristinaVersione(row){
        let me = this;
        me.itemRecovery = row.item;
        me.itemRecovery.recovery = true;
        me.$refs.mdlRecoveryRecord.show();
       
    },
    onRipristina(){
      let me = this;
       let link = process.env.VUE_APP_PATH_API + me.pathResource;
        axios.post(link,me.itemRecovery)
        .then((response)=>{
        console.log(response);
        
      }).catch((err)=>{
        console.log(err);
      });

    },
    onAnnullaRipristino(){
      let me = this;
      me.$refs.mdlRecoveryRecord.hide();
      me.itemRecovery= { versione:0 };
    },
    onDeleteItem(row) {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + row.id;
      axios
        .delete(link)
        .then(() => {
          me.showModalLoading = false;
          me.loadData();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onOpenPdfViewer(row) {
      let me = this;
      row;
      me.$refs.pdfPrintViewEmbedded.show();
    },
  },
  watch: {
    currentPageReportName() {
      let me = this;
      me.loadData();
    },
  },
};
</script>
